export default function EqualCircle({ className, ...rest }: { className?: string }) {
  return (
    <svg
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      className={className}
    >
      <path
        d="M23.03.047c-.157.018-.69.073-1.184.123-3.985.398-8.204 2.042-11.525 4.491-4.051 2.988-7.004 7.053-8.569 11.795-1.653 5.011-1.653 10.097 0 15.108a23.927 23.927 0 0 0 16.911 15.715c2.199.55 2.83.617 5.837.617 3.007 0 3.638-.067 5.837-.617 9.114-2.282 16.068-9.716 17.757-18.982.27-1.479.359-2.525.361-4.246.003-1.86-.103-3.001-.437-4.696a23.568 23.568 0 0 0-3.655-8.779C40.465 4.826 34.392 1.093 27.481.2c-.939-.122-3.853-.221-4.451-.153m2.98 1.507c4.205.303 8.017 1.649 11.422 4.031 2.27 1.589 4.545 3.968 6.049 6.325 1.824 2.858 3.045 6.356 3.399 9.732.126 1.204.126 3.532 0 4.736-.806 7.691-5.583 14.488-12.58 17.901-5.424 2.646-11.968 2.957-17.64.838-7.146-2.67-12.501-8.826-14.133-16.248-.366-1.663-.502-2.979-.502-4.859 0-1.885.136-3.194.506-4.88C3.882 12.971 7.845 7.614 13.413 4.417c2.794-1.605 6.161-2.626 9.433-2.86 1.303-.094 1.9-.094 3.164-.003m-7.69 19.227c-.315.137-.435.343-.435.749 0 .222.061.37.219.536l.22.229h12.333l.229-.219c.248-.238.312-.698.141-1.018-.211-.395-.24-.397-6.545-.393-4.833.002-5.95.023-6.162.116m-.216 5.173c-.237.248-.296.699-.131 1.008.211.394.243.396 6.527.396s6.316-.002 6.527-.396c.171-.32.107-.78-.141-1.018l-.229-.219H18.324l-.22.229"
        fillRule="evenodd"
        fill="currentColor"
      />
    </svg>
  )
}
